

import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "./ui/dialog";
import { useTranslation } from "react-i18next";
import { ScrollArea } from "./ui/scroll-area";

const TermsAndConditions = () => {
    const { t } = useTranslation("settings");
    return (
        <>
            <Dialog >
                <DialogTrigger>
                    <span className="underline">Terms and Conditions</span>
                </DialogTrigger>
                <DialogContent className="max-w-5xl">
                    <DialogHeader>

                        <DialogTitle >Terms and conditions</DialogTitle>
                    </DialogHeader>

                    <ScrollArea className="flex  flex-col gap-4 max-h-screen overflow-hidden">
                        <div >
                            <p >
                                If you continue to browse and use this website, you are agreeing
                                to comply with and be bound by the following terms and
                                conditions of use, which together with our privacy policy govern
                                Level2 Technologies Ltd relationship with you in
                                relation to this website. If you disagree with any part of these
                                terms and conditions, please do not use our website.
                            </p>
                        </div>
                        <div className="flex flex-col gap-4">
                            <p>
                                The term &apos;Level2&apos; or &apos;us&apos; or
                                &apos;we&apos; refers to the owner of the website. The term
                                &apos;you&apos; refers to the user or viewer of our website:
                            </p>

                            <ul className="flex flex-col gap-4">
                                <li >
                                    The use of this website is subject to the following terms of
                                    use;
                                </li>
                                <li>
                                    The content of the pages of this website is for your general
                                    information and use only. It is subject to change without
                                    notice;
                                </li>
                                <li>
                                    This website uses cookies to monitor browsing preferences;
                                </li>
                                <li>
                                    Neither we nor any third parties provide any warranty or
                                    guarantee as to the accuracy, timeliness, performance,
                                    completeness or suitability of the information and materials
                                    found or offered on this website for any particular purpose.
                                    You acknowledge that such information and materials may
                                    contain inaccuracies or errors and we expressly exclude
                                    liability for any such inaccuracies or errors to the fullest
                                    extent permitted by law;
                                </li>
                                <li>
                                    Your use of any information or materials on this website is
                                    entirely at your own risk, for which we shall not be liable.
                                    It shall be your own responsibility to ensure that any
                                    products, services or information available through this
                                    website meet your specific requirements;
                                </li>
                                <li>
                                    This website contains material which is owned by or licensed
                                    to us. This material includes, but is not limited to, the
                                    design, layout, look, appearance and graphics. Reproduction is
                                    prohibited other than in accordance with the copyright notice,
                                    which forms part of these terms and conditions;
                                </li>
                                <li>
                                    All trademarks reproduced in this website, which are not the
                                    property of, or licensed to the operator, are acknowledged on
                                    the website;
                                </li>
                                <li>
                                    Unauthorised use of this website may give rise to a claim for
                                    damages and/or be a criminal offence;
                                </li>
                                <li>
                                    From time to time, this website may also include links to
                                    other websites. These links are provided for your convenience
                                    to provide further information. They do not signify that we
                                    endorse the website(s). We have no responsibility for the
                                    content of the linked website(s);
                                </li>
                                <li>
                                    Your use of this website and any dispute arising out of such
                                    use of the website is subject to the laws of England, Northern
                                    Ireland, Scotland and Wales.
                                </li>
                                <li>
                                    The Level2 service and its content should not be
                                    construed as a solicitation to invest and/or trade. You should
                                    seek independent advice in this regard;
                                </li>
                                <li>
                                    Past performance is not indicative of future performance. No
                                    representation is being made that any results discussed within
                                    the service and its related media content will be achieved;
                                </li>
                                <li>
                                    All opinions, news, research, analyses, prices or other
                                    information is provided as general market commentary and not
                                    as investment advice. Level2, their members,
                                    shareholders, employees, agents, representatives and resellers
                                    do not warrant the completeness, accuracy or timeliness of the
                                    information supplied, and they shall not be liable for any
                                    loss or damages, consequential or otherwise, which may arise
                                    from the use or reliance of the Level2 service and
                                    its content.
                                </li>
                            </ul>
                        </div>
                    </ScrollArea>
                </DialogContent>
            </Dialog>
        </>
    )
}
export default TermsAndConditions;